import { atom } from 'jotai'
import { TProduct } from '../types/product.types'

export const productsState = atom<TProduct[]>([])
export const availableProductWarehousesState = atom<string[]>([])

export const resolveProductWarehouse = (requestedWarehouse: string, availableWarehouses: string[]) =>
    availableWarehouses.length === 1 ? availableWarehouses[0] : requestedWarehouse
